import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) {
    return router.createUrlTree(['/']);
  }
  if (auth.needsBusinessSetup()) {
    return router.createUrlTree(['/login']);
  }
  return true;
};

/** Payment Schedule page is available only when login isPaymentSchedule is 1. */
export const paymentScheduleGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isPaymentScheduleEnabled()) return true;
  return router.createUrlTree(['/dashboard']);
};

/** Sub Users page is available only when login isSubUser is 0 (parent). */
export const subUserGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.canManageSubUsers()) return true;
  return router.createUrlTree(['/dashboard']);
};

/** Login route: send completed sessions to dashboard. */
export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isFullyAuthenticated()) {
    return router.createUrlTree(['/dashboard']);
  }
  return true;
};
